import React from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from '@material-ui/lab/Skeleton';

export default function SkeletonReviewContent(props) {
  return (
    <Grid container direction="row" justify="space-between" alignItems="flex-start">
      <Grid item style={{ maxWidth: 872, width: '100%' }}>
        <Grid item>
          <Skeleton animation="wave" variant="rect" height={156} style={{ borderRadius: 16, width: '100%' }} />
        </Grid>
      </Grid>

      <Grid item style={{ minWidth: 311 }}>
        <Skeleton animation="wave" variant="text" height={40} />

        <Skeleton animation="wave" variant="text" height={40} />

        <Skeleton animation="wave" variant="text" height={40} />

        <Skeleton animation="wave" variant="text" height={40} />
      </Grid>
    </Grid>
  )
}